








































































































import { Language } from "@/services/language/entities/language.interface";
import { Translate } from "@/services/language/entities/translate.interface";
import { Page } from "@/services/settings/entities/page.interface";
import Vue from "vue";
import Component from "vue-class-component";
import { Prop, Watch } from "vue-property-decorator";
import rules from "../../utils/rules";

@Component
export default class CreatePageDialog extends Vue {
  @Prop() dialogCreate!: boolean;
  @Prop({ required: false }) editPage!: Page | undefined;
  $refs!: {
    formCreate: HTMLFormElement;
  };

  generalRules = [rules.notEmpty];
  valid = true;
  loadingCreate = false;
  snackbarSuccessCreate = false;
  snackbarErrorCreate = false;
  url = "";
  icon = "";
  name: Array<Translate> = [];
  private created() {
    if (this.editPage) {
      this.url = this.editPage.pagePath;
      this.icon = this.editPage.pageIcon;
    }
    this.$store.dispatch("language/getLanguages").then(() => {
      this.languages.forEach((language: Language) => {
        const foundEdit = this.editPage?.pageNameTranslate?.find(
          (lang) => lang.iso == language.cb_language_iso
        );
        this.name.push({
          languageID: language.cb_language_id,
          languageName: language.cb_language_name,
          iso: language.cb_language_iso,
          text: foundEdit?.text || "",
        });
      });
    });
  }
  private cancelCreate(): void {
    this.$emit("cancelCreate");
  }

  private createPage(): void {
    this.loadingCreate = true;
    const nameTranslate = this.name.map((translate: Translate) => {
      return { iso: translate.iso, text: translate.text };
    });
    this.$store
      .dispatch(this.isEdit ? "settings/updatePage" : "settings/createPage", {
        fields: [
          {
            name: this.editPage ? this.editPage.pageName : "name",
            translate: nameTranslate,
          },
        ],
        icon: this.icon,
        path: this.url,
        ...(this.isEdit ? { pageId: this.editPage?.pageID } : {}),
      })
      .then((response: boolean) => {
        if (response) {
          this.snackbarSuccessCreate = true;
          this.$refs.formCreate.reset();
          this.$emit("cancelCreate");
        } else {
          this.snackbarErrorCreate = true;
        }

        this.loadingCreate = false;
      });
  }

  private openMaterialDesignIcons(): void {
    window.open(process.env.VUE_APP_MATERIAL_DESIGN_ICON);
  }
  private get languages(): Array<Language> {
    return this.$store.getters["language/getLanguages"];
  }
  get isEdit() {
    return this.editPage != undefined;
  }
}
